var _g, _path, _path2, _path3, _g2, _g3, _g4, _path4, _path5, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_21598_21596)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 36,
    height: 36,
    rx: 8,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4246 7.28248C12.2062 5.50089 14.6226 4.5 17.1421 4.5H29C30.933 4.5 32.5 6.067 32.5 8V36.6667C32.5 38.5997 30.933 40.1667 29 40.1667H7C5.067 40.1667 3.5 38.5997 3.5 36.6667V18.1421C3.5 15.6226 4.50089 13.2062 6.28249 11.4246L10.4246 7.28248Z",
    fill: "#FF6300",
    stroke: "#FF6300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8335 20.1667H26.3335",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 26H16",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_21598_21596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.643 6.35702L5.92893 11.0711C4.05357 12.9464 3 15.5145 3 18.1667C3.02344 15.8587 4.90108 14 7.2092 14H10.1365C11.718 14 13 12.718 13 11.1365V7.35292C13 5.50879 14.4892 4.01081 16.3333 4C14.199 4 12.1522 4.84784 10.643 6.35702Z",
    fill: "#FFA300"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_21598_21596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4165 24L3.4165 18.5833L3.42866 17.3862C3.44537 15.7413 4.78354 14.4167 6.42851 14.4167H8.4165C11.1779 14.4167 13.4165 12.1781 13.4165 9.41667V7.41867C13.4165 5.76868 14.749 4.42839 16.3989 4.41872L16.7498 4.41667H21.3332",
    stroke: "#FF6300"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_21598_21596)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 36,
    height: 36,
    rx: 8,
    fill: "url(#paint0_linear_21598_21596)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 36,
    height: 36,
    rx: 8,
    fill: "url(#paint1_radial_21598_21596)",
    fillOpacity: 0.5
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7508 49.5014H36.7508C35.5108 49.5014 34.5108 48.4814 34.5008 47.2514V44.2514C34.5108 43.6514 34.2608 43.1014 33.8208 42.7214C32.0708 41.2814 31.0408 39.1514 31.0008 36.8814C30.9708 34.8114 31.7408 32.8514 33.1808 31.3714C34.6108 29.8814 36.5508 29.0414 38.6208 29.0014C40.7008 28.9614 42.7208 29.7614 44.1908 31.2214C44.3608 31.3914 44.5308 31.5714 44.6808 31.7614C46.0108 33.3514 46.6408 35.3614 46.4608 37.4314C46.2808 39.4914 45.3008 41.3614 43.7108 42.7014C43.2508 43.0914 42.9908 43.6514 42.9908 44.2514V47.2514C42.9908 48.4814 41.9708 49.4914 40.7408 49.5014H40.7508ZM36.8108 46.7014C36.8108 46.8671 36.9452 47.0014 37.1108 47.0014H40.3708C40.5365 47.0014 40.6708 46.8671 40.6708 46.7014V45.5309C40.6708 45.3652 40.5365 45.2309 40.3708 45.2309H37.1108C36.9452 45.2309 36.8108 45.3652 36.8108 45.5309V46.7014ZM40.4461 43.0014C40.5793 43.0014 40.6956 42.9132 40.7395 42.7874C40.9967 42.0509 41.4522 41.3762 42.0908 40.8014L42.4608 40.4314C44.4908 38.3714 44.4608 35.0414 42.4008 33.0114C41.4208 32.0214 40.0308 31.4514 38.6708 31.5014C37.2708 31.5314 35.9208 32.1414 34.9608 33.1714C34.8508 33.2814 34.7608 33.3914 34.6608 33.5014C33.7908 34.5714 33.3808 35.9214 33.5208 37.3014C33.6608 38.6814 34.3308 39.9214 35.4008 40.7914C36.0312 41.3213 36.4947 42.0098 36.7455 42.7806C36.7875 42.9098 36.9053 43.0014 37.0412 43.0014H40.4461Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7508 48.5014H35.7508C34.5108 48.5014 33.5108 47.4814 33.5008 46.2514V43.2514C33.5108 42.6514 33.2608 42.1014 32.8208 41.7214C31.0708 40.2814 30.0408 38.1514 30.0008 35.8814C29.9708 33.8114 30.7408 31.8514 32.1808 30.3714C33.6108 28.8814 35.5508 28.0414 37.6208 28.0014C39.7008 27.9614 41.7208 28.7614 43.1908 30.2214C43.3608 30.3914 43.5308 30.5714 43.6808 30.7614C45.0108 32.3514 45.6408 34.3614 45.4608 36.4314C45.2808 38.4914 44.3008 40.3614 42.7108 41.7014C42.2508 42.0914 41.9908 42.6514 41.9908 43.2514V46.2514C41.9908 47.4814 40.9708 48.4914 39.7408 48.5014H39.7508ZM35.8108 45.7014C35.8108 45.8671 35.9452 46.0014 36.1108 46.0014H39.3708C39.5365 46.0014 39.6708 45.8671 39.6708 45.7014V44.5309C39.6708 44.3652 39.5365 44.2309 39.3708 44.2309H36.1108C35.9452 44.2309 35.8108 44.3652 35.8108 44.5309V45.7014ZM39.4461 42.0014C39.5793 42.0014 39.6956 41.9132 39.7395 41.7874C39.9967 41.0509 40.4522 40.3762 41.0908 39.8014L41.4608 39.4314C43.4908 37.3714 43.4608 34.0414 41.4008 32.0114C40.4208 31.0214 39.0308 30.4514 37.6708 30.5014C36.2708 30.5314 34.9208 31.1414 33.9608 32.1714C33.8508 32.2814 33.7608 32.3914 33.6608 32.5014C32.7908 33.5714 32.3808 34.9214 32.5208 36.3014C32.6608 37.6814 33.3308 38.9214 34.4008 39.7914C35.0312 40.3213 35.4947 41.0098 35.7455 41.7806C35.7875 41.9098 35.9053 42.0014 36.0412 42.0014H39.4461Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_21598_21596)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 20.5,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "url(#paint2_radial_21598_21596)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 20.5,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "url(#paint3_radial_21598_21596)",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 20.5,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "url(#paint4_radial_21598_21596)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_21598_21596",
    x: 16,
    y: 16,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21598_21596"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21598_21596",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_21598_21596",
    x: -5,
    y: -4,
    width: 29.3335,
    height: 30.1667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21598_21596"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21598_21596",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_21598_21596",
    x: -5.0835,
    y: -4.08334,
    width: 34.4165,
    height: 36.0833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21598_21596"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21598_21596",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_21598_21596",
    x: 12,
    y: 12,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21598_21596"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21598_21596",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_21598_21596",
    x: 16,
    y: 16,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21598_21596"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21598_21596",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21598_21596",
    x1: 20,
    y1: 20,
    x2: 38,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_21598_21596",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 20) scale(36)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_21598_21596",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5 43.5) rotate(6.1155) scale(14.0801)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_21598_21596",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5 26.5) rotate(135) scale(6.36396 28.1317)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_21598_21596",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5 27) rotate(116.565) scale(16.7705)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.458504b86bd92a23066166928f7e1d97.svg";
export { ForwardRef as ReactComponent };